import { Progress, Rating, TextAlignment } from '@makyoapp/makyo-tw-ui'

import { SpacingInputValue } from '@/shared/builder'
import { CompLinearProgressProps } from '@/components/__project__/core/linear-progress/comp'
import { CompRatingProps } from '@/components/__project__/core/rating/comp'

import { LayoutDemo } from './LayoutDemo'

export const RatingProgressDemo = () => {
  const ratingProps: CompRatingProps = {
    id: 'rating-progress-indicator',
    alignment: 'parent',
    margin: '0' as unknown as SpacingInputValue,
    backgroundColor: 'primary-80',
    value: 3,
    count: 5,
    interval: 1,
    size: 'md',
    readOnly: true,
  }

  const linearProgressProps: CompLinearProgressProps = {
    alignment: 'center',
    backgroundColor: 'primary-80',
    height: '10px',
    max: 100,
    value: 25,
    valueAlignment: 'end' as TextAlignment,
    valueSpacing: '0' as unknown as SpacingInputValue,
    valueTypography: { typography: 'Body Small' },
    width: '100%',
  }

  return (
    <LayoutDemo title='Rating & Linear Progress' bgColor='var(--color-primary-80)'>
      <div className='flex flex-col gap-8 w-full items-center justify-center'>
        <Rating {...ratingProps} />
        <Progress {...linearProgressProps} />
      </div>
    </LayoutDemo>
  )
}
